'use strict';

var React = require('react');
var cs = require('classnames');
var components_Avatar_components_avatarInitialsSvg_index = require('./components/avatarInitialsSvg/index.js');
var components_Avatar_components_avatarDefaultSvg_index = require('./components/avatarDefaultSvg/index.js');
var components_Avatar_constants_index = require('./constants/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cs__default = /*#__PURE__*/_interopDefaultLegacy(cs);

/**
 * The Avatar component is used to show a user's avatar. It can use an image url or initials.
 * If none are provided, then a default (SVG) image is shown.
 */
const Avatar = ({ size = components_Avatar_constants_index.DEFAULT_PROPS.size, initials = "", imageSrc = "", className = "", foregroundColor = components_Avatar_constants_index.DEFAULT_PROPS.foregroundColor, backgroundColor = components_Avatar_constants_index.DEFAULT_PROPS.backgroundColor, }) => {
    const [imgHasError, setImgHasError] = React.useState(false);
    const imgProps = { width: size, height: size, src: imageSrc };
    const svgProps = { size, foregroundColor, backgroundColor };
    const initialsSvgProps = { ...svgProps, initials };
    const canShowImg = imageSrc && !imgHasError;
    const onErrorHandler = () => setImgHasError(true);
    return (React__default['default'].createElement("div", { className: cs__default['default']("ss-inline-block ss-align-middle ss-overflow-hidden ss-rounded-full", className) },
        canShowImg && React__default['default'].createElement("img", Object.assign({ alt: "" }, imgProps, { onError: onErrorHandler })),
        !canShowImg && initials && React__default['default'].createElement(components_Avatar_components_avatarInitialsSvg_index, Object.assign({}, initialsSvgProps)),
        !canShowImg && !initials && React__default['default'].createElement(components_Avatar_components_avatarDefaultSvg_index, Object.assign({}, svgProps))));
};

module.exports = Avatar;
